import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import Navigation from "./navigation"
 
class ProtectedRoute extends React.Component {
    

    render() {
        const Component = this.props.component;
        const token = localStorage.getItem("accessToken");
        const isTokenExpired = token ? Date.now() > jwt_decode(token).exp * 1000 : false;
        if (isTokenExpired) localStorage.removeItem("accessToken");

        return token && !isTokenExpired ? (
            <><Navigation /><Component /></>
        ) : (
            <Redirect to={{ pathname: '/login' }} />
        );
    }
}

export default withRouter(ProtectedRoute);